<template>
	<div class="home" @click="closeCommonPop">
		<el-container>
			<!-- 头部 -->
			<el-header class="header">
				<div class="service-info">
					<div class="service-left" @click.stop="showStatusOrInfo">
						<img data-type='img' class="service-img" :src="userinfo.portrait">
						<i class="iconfont icondian" v-show="service_status==0" style="color:green;"></i>
						<i class="iconfont iconquxiao" v-show="service_status==1" style="color:#000;"></i>
						<i class="iconfont iconmanglu" v-show="service_status==2" style="color:#e51414;"></i>
						<i class="iconfont iconyinshencopy" v-show="service_status==3" style="color:#ffa831;"></i>
					</div>
					<div class="service-right">
						<span class="service-name">{{userinfo.userCode}}</span>
						<span class="service-id">id{{userinfo.id}}</span>
					</div>
					<div v-show="show_status_bar" class="service-status triangle">
						<div class="status-item" @click.stop="changServiceStatus(0)">
							<i class="iconfont icondian" style="color:green;"></i>
							<span>在线</span>
							<i v-show="service_status==0" class="iconfont icongouxuandanxuan"></i>
						</div>
						<div class="status-item" @click.stop="changServiceStatus(1)">
							<i class="iconfont iconquxiao"></i>
							<span>离线</span>
							<i v-show="service_status==1" class.stop="iconfont icongouxuandanxuan"></i>
						</div>
						<div class="status-item" @click.stop="changServiceStatus(2)">
							<i class="iconfont iconmanglu" style="color:#e51414;"></i>
							<span>忙碌</span>
							<i v-show="service_status==2" class="iconfont icongouxuandanxuan"></i>
						</div>
						<div class="status-item" @click.stop="changServiceStatus(3)">
							<i class="iconfont iconyinshencopy" style="color:#ffa831;"></i>
							<span>隐身</span>
							<i v-show="service_status==3" class="iconfont icongouxuandanxuan"></i>
						</div>
					</div>
				</div>
				<!-- 数据统计 -->
				<div class="data-statistics">
					<div class="data-statistics-item right-border">
						<span class="data-statistics-num">{{Census.jd_num}}</span>
						<span class="data-statistics-type">今日接待</span>
					</div>
					<div class="data-statistics-item right-border">
						<span class="data-statistics-num">{{Census.wxd_num}}</span>
						<span class="data-statistics-type">未下单</span>
					</div>
					<div class="data-statistics-item right-border">
						<span class="data-statistics-num">{{Census.wfk_num}}</span>
						<span class="data-statistics-type">未付款</span>
					</div>
					<div class="data-statistics-item">
						<span class="data-statistics-num">{{Census.yfk_num}}</span>
						<span class="data-statistics-type">已付款</span>
					</div>
				</div>
				<!-- 消息分类 -->
				<div class="message-cate">
					<span class="message-item right-border" @click="showUserMessage(1)">退款消息</span>
					<span class="message-item right-border" @click="showUserMessage(2)">交易消息</span>
					<span class="message-item right-border">处罚与预警</span>
					<span class="message-item">其他消息</span>
				</div>
				<!-- 设置 -->
				<div class="setting">
					<i class="iconfont iconshengyin"></i>
					<i class="iconfont iconshezhi" @click.stop="showSetting"></i>
					<!-- 设置下拉菜单 -->
					<div class="setting_dropdown triangle" v-show="show_setting_dropdown">
						<div class="setting_dropdown_item" @click.stop="logoutAccount">注销账号</div>
						<div class="setting_dropdown_item" @click.stop="logout">退出</div>
					</div>
				</div>
			</el-header>
			<!-- 客服信息弹窗 -->
			<ServiceInformation @closePop="closePop" :userinfo="userinfo" class="service-information" v-show="show_service_info">
			</ServiceInformation>
			<CancellationReason @closePop="closePop" :User_code="usercode" v-show="show_cancellation_reason"></CancellationReason>
			<SystemSetting @editDisturb="getServiceInfo" @closePop="closePop" :User_code="usercode" :signature="userinfo.qm" ref="SystemSetting"
			 class="system_setting" v-show="show_system_setting"></SystemSetting>
			<el-container class="main-container">
				<!-- 左侧联系人消息列表 -->
				<el-aside class="message_contact_list">
					<el-input class="search-box" placeholder="请输入联系人,聊天记录" prefix-icon="el-icon-search" @change="search" v-model="searchText"
					 clearable></el-input>
					<!-- 搜索结果列表 -->
					<div class="search-result" v-show="searchUserData.length>0||searchChatData.length>0">
						<!-- 联系人搜索结果 -->
						<p v-show="searchUserData.length>0">联系人</p>
						<li v-for="(item,index) in searchUserData" :class="item.msgkey==msgkey ? 'Msgactive' : '' " @click="openChat(item.msgkey,item.user_id,item.real_name,item.portrait,item.store_id)">
							<img :src="item.portrait">
							<span>{{item.real_name}}</span>
						</li>
						<!-- 聊天历史搜索结果 -->
						<p v-show="searchChatData.length>0">近期聊天记录</p>
						<li v-for="(item,index) in searchChatData" :class="item.msgkey==msgkey ? 'Msgactive' : '' " @click="openChat(item.new_msg.msgkey,item.userInfo[0].user_id,item.userInfo[0].real_name,item.userInfo[0].portrait,item.new_msg.store_id)">
							<img :src="item.userInfo[0].portrait">
							<div class="search-message">
								<span class="text-ellipsis">{{item.userInfo[0].real_name}}</span>
								<span class="text-ellipsis">{{item.new_msg.message}}</span>
							</div>

						</li>
					</div>
					<!-- 联系人 -->
					<div class="search-tab" @click="changeTab">
						<i data-active='0' :class="['iconfont','iconxiaoxi',isActive==0 ? 'active' : '']"></i>
						<i data-active='1' :class="['iconfont','iconwodeguanzhu',isActive==1 ? 'active' : '']"></i>
						<i data-active='2' :class="['iconfont','iconwodetuandui',isActive==2 ? 'active' : '']"></i>
					</div>
					<div class="search-title">
						<span>接待：{{messageList.length}}</span>
						<span @click="sortReverse(messageList)">排序<i class="iconfont iconpaixu"></i></span>
					</div>
					<!-- 消息列表 -->
					<ul class="message-list" style="overflow:auto" v-infinite-scroll="loadLeftList" :infinite-scroll-disabled="false">
						<li :class="['message-list-item',item.msgkey==msgkey ? 'Msgactive' : '']" v-for="(item,index) in messageList"
						 :key="index" @click="openChat(item.msgkey,item.user_id,item.real_name,item.portrait,item.new_msg.store_id);markReaded(item.msgkey)">
							<img :src="item.portrait">
							<!-- not_read_msg_list.includes(item.msgkey) -->
							<span>
								<span class="message-name message-name-small">{{item.real_name[0]}}</span>
								<span class="message-name">{{item.real_name[1]}}</span>
							</span>
							<span v-show="not_read_msg_list.includes(item.msgkey)" class="msg-warn-flag"></span>
						</li>
					</ul>
					<!-- 底部功能栏-->
					<div class="foot-bar">
						<i class="iconfont iconfenlei" @click="showSystemSet" title="系统设置"></i>
						<i class="iconfont iconshangpin" @click="showGoods" title="商品"></i>
						<i class="iconfont iconagent" @click="showOperatingFloor" title="商户管理后台"></i>
					</div>
				</el-aside>
				<!-- 聊天内容区域 -->
				<el-main class="chat-area">
					<div class="chat-top" v-show="!chat_id">
						无接待
					</div>
					<div class="chat-top" v-show="chat_id">
						<div class="chat-top-box">
							<img class="chat-target-img" :src="chat_headImg">
							<span class="chat-target-name">{{chat_name}}</span>
						</div>
						<div class="chat-top-box" @click="addFriend">
							<i class="iconfont iconfiladaogou-tianjiahaoyou"></i>
						</div>
					</div>
					<div class="chat-main">
						<audio ref="audio1" autoplay="autoplay" id="audio"></audio>
						<audio ref="audio" src="@/static/remind.mp3" id="remind_audio" style="visibility: hidden;"></audio>
						<video autoplay="autoplay" class="video" :src="videoSrc" v-if="videoSrc"></video>
						<i class="iconfont iconquxiao close-video" v-show="videoSrc" @click="closeVideo"></i>
						<div class="chat-message" id="msgScroll">
							<div class="message-item-bytime clearfix" v-for="(v,i) in chatList">
								<div :class="['message-content',val.send_id!=usercode ? 'f_left' : 'f-right']" v-for="(val,idx) in v" :id="i==chatList.length-1&&idx==v.length-1&&'msg_end'">
									<div :class="['message-item-name',val.send_id==usercode?'self-name':'chat-name']">{{val.send_id==usercode?userinfo.userCode:chat_name}}
										<span class="msg-record-time">{{val.add_time}}</span></div>
									<div :class="['message-item-content-container',val.send_id!=usercode ? 'f-left' : 'f-right',val.send_id!=usercode ? '' : 'text-right',i==chatList.length-1&&idx==v.length-1 ? 'end':'']">
										<p v-if="val.msg_type==0">{{val.message}}<span class="message-label" v-if="!val.not_read&&val.send_id==usercode">已读</span></p>
										<p v-if="val.msg_type==1" @click="playAudio(val.message)">
											<i class="iconfont iconyuyin2"></i>
											<span class="message-label" v-if="!val.not_read&&val.send_id!=usercode">已读</span>
										</p>
										<p v-if="val.msg_type==2" :class="['message-img',val.is_new==0&&val.send_id==usercode ? 'message-lable' : '']">
											<el-image style="width: 100px; height: 100px;" :src="val.message" :preview-src-list="[val.message]">
											</el-image>
											<span class="message-label" v-if="!val.not_read&&val.send_id==usercode">已读</span>
										</p>
										<p v-if="val.msg_type==5" :class="['message-img',val.is_new==0&&val.send_id==usercode ? 'message-lable' : '']">
											<img :src="val.message" />
											<span class="message-label" v-if="!val.not_read&&val.send_id==usercode">已读</span>
										</p>
										<p v-if="val.msg_type==3" :class="['message-img',val.is_new==0&&val.send_id==usercode ? 'message-lable' : '']">
											<img src="@/static/default-video.png" @click="playVideo(val.message)" />
											<span class="message-label" v-if="!val.not_read&&val.send_id==usercode">已读</span>
										</p>
										<p v-if="val.msg_type==6" :class="['message-img','clearfix','message-goods',val.is_new==0&&val.send_id==usercode ? 'message-lable' : '']">
											<span class="goods-left">
												<img :src="val.message.default_image" />
											</span>
											<span class="goods-right">
												<div class="msg-goods-name">{{val.message.goods_name}}</div>
												<p class="msg-goods-price">价格:&nbsp;￥{{val.message.price}}</p>
											</span>
										</p>
										<p v-if="val.msg_type==4" :class="['message-img',val.is_new==0&&val.send_id==usercode ? 'message-lable' : '']">
											<span class="order">
												<span class="order-title">请你核对订单信息</span>
												<span class="order-goods">
													<span class="order-goods-left">
														<img :src="val.message.goods_image" />
													</span>
													<span class="order-goods-right clearfix">
														<span class="order-goods-name text-ellipsis" v-if="val.message.goods_name">{{val.message.goods_name}}</span>
														<span class="order-goods-num" v-if="val.message.open_quantity">共{{val.message.open_quantity}}件商品</span>
														<span class="order-goods-totalprice" v-if="val.message.open_orderprice">合计￥{{val.message.open_orderprice}}</span>
													</span>
												</span>
												<span class="order-username" v-if="val.message.consignee">姓名:{{val.message.consignee}}</span>
												<span class="order-phone" v-if="val.message.phone_mob">电话:{{val.message.phone_mob}}</span>
												<span class="order-address" v-if="val.message.open_address">地址:{{val.message.open_address}}</span>
											</span>
											<span class="message-label" v-if="!val.not_read&&val.send_id==usercode">已读</span>
										</p>
									</div>
								</div>
							</div>
						</div>
						<div class="chat-tool" @click="inputGetFocus">
							<div class="toolbar">
								<div class="left-bar">
									<el-popover placement="top" width="400" trigger="click">
										<div class="emoji-box" @click.stop="sendEmoji">
											<div class="emoji-row">
												<img src="@/static/emoji/emoji0.png" data-src="../../image/emoji/emoji0.png">
												<img src="@/static/emoji/emoji1.png" data-src="../../image/emoji/emoji1.png">
												<img src="@/static/emoji/emoji2.png" data-src="../../image/emoji/emoji2.png">
												<img src="@/static/emoji/emoji3.png" data-src="../../image/emoji/emoji3.png">
												<img src="@/static/emoji/emoji4.png" data-src="../../image/emoji/emoji4.png">
												<img src="@/static/emoji/emoji5.png" data-src="../../image/emoji/emoji5.png">
												<img src="@/static/emoji/emoji6.png" data-src="../../image/emoji/emoji6.png">
												<img src="@/static/emoji/emoji7.png" data-src="../../image/emoji/emoji7.png">
											</div>
											<div class="emoji-row">
												<img src="@/static/emoji/emoji8.png" data-src="../../image/emoji/emoji8.png">
												<img src="@/static/emoji/emoji9.png" data-src="../../image/emoji/emoji9.png">
												<img src="@/static/emoji/emoji10.png" data-src="../../image/emoji/emoji10.png">
												<img src="@/static/emoji/emoji11.png" data-src="../../image/emoji/emoji11.png">
												<img src="@/static/emoji/emoji12.png" data-src="../../image/emoji/emoji12.png">
												<img src="@/static/emoji/emoji13.png" data-src="../../image/emoji/emoji13.png">
												<img src="@/static/emoji/emoji14.png" data-src="../../image/emoji/emoji14.png">
												<img src="@/static/emoji/emoji15.png" data-src="../../image/emoji/emoji15.png">
											</div>

										</div>
										<i class="iconfont iconSmile" id="emojibtn" slot="reference"></i>
									</el-popover>
									<el-upload :action='"/api/upload/upload"' :show-file-list="false" :on-success="uploadFile" :data="uploadData"
									 :auto-upload="true" class="upload-file">
										<i class="iconfont icontupian" @click="toolClickHandler(1)"></i>
									</el-upload>
									<el-upload :action='"/api/upload/upload"' :show-file-list="false" :on-success="uploadFile" :data="uploadData"
									 :auto-upload="true" class="upload-file">
										<i class="iconfont iconshipin" @click="toolClickHandler(2)"></i>
									</el-upload>
								</div>
								<div class="right-bar">
									<i class="iconfont iconxiaoxi" @click.stop="toolClickHandler(3)"></i>
									<i class="iconfont iconshijian" @click.stop="toolClickHandler(4)"></i>
								</div>
							</div>
							<textarea cols="30" rows="10" ref="textarea" v-model="msgData" @keyup.enter="sendMessage" class="msg-textarea"></textarea>
							<button class="msg-btn1" @click.stop="closeChat">关闭</button>
							<button class="msg-btn2" @click.stop="sendMessage">发送</button>
						</div>
					</div>
				</el-main>
				<!-- 右侧功能区域 -->
				<el-aside class="goods-notice-area">
					<QuickPhrases v-show="left_status==4" ref='phrases' class="quick-phrases" :chatList="chatList" :msgkey="msgkey"
					 @openDialog="openPhrasesDialog" :User_code="usercode"></QuickPhrases>
					<ChatRecord v-show="left_status==5" ref="chatrecord" class="chat-record" :friend_id="chat_id" :chat_name="chat_name"
					 :msgkey="msgkey" :User_code="usercode" :username="userinfo.real_name"></ChatRecord>
					<GoodsList v-if="chat_id" v-show="left_status==6" ref="goodslist" :User_code="usercode" :friend_id="chat_id"
					 :msgkey="msgkey" :store_id="userinfo.store_id" class="goodslist"></GoodsList>
					<News v-if="left_status!=4&&left_status!=5&&left_status!=6" ref="newslist" :friend_id="chat_id" :msgkey="msgkey" :store_id="userinfo.store_id" :User_code="usercode" :status="left_status" ></News>
				</el-aside>
			</el-container>
			<!-- 添加快捷短语弹出框 -->
			<el-dialog title="添加短语" :visible.sync="dialogPhrasesVisible" class="phrases-dialog" width="30%">
				<el-input type="textarea" placeholder="请输入快捷短语" v-model="phrases_textarea" maxlength="50" show-word-limit resize='none'
				 center="true">
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="handlePhrasesClose('cancel')">取消</el-button>
					<el-button type="primary" @click="handlePhrasesClose('define')">确定</el-button>
				</span>
			</el-dialog>
		</el-container>
	</div>
</template>

<script>
	// @ is an alias to /src
	import ServiceInformation from '@/components/ServiceInformation.vue'
	import CancellationReason from '@/components/CancellationReason.vue'
	import QuickPhrases from '@/components/QuickPhrases.vue'
	import ChatRecord from '@/components/ChatRecord.vue'
	import GoodsList from '@/components/GoodsList.vue'
	import SystemSetting from '@/components/SystemSetting.vue'
	import News from '@/components/News.vue'

	import '@/style/check.order.css'
	import '@/style/chat.css'
	import {
		Loading
	} from 'element-ui';
	// import {getServiceStatus} from '../util/request.js'

	export default {
		name: 'Home',
		components: {
			ServiceInformation,
			CancellationReason,
			QuickPhrases,
			ChatRecord,
			GoodsList,
			SystemSetting,
			News
		},
		data() {
			return {
				usercode: '726', // 客服账号
				show_status_bar: false, //是否显示状态栏
				show_setting_dropdown: false, //显示设置下拉菜单
				service_status: 0, //客服状态
				userinfo: {
					header_img: '', //用户头像
					id: '', //客服id
				},
				searchText: '', //搜索内容
				isActive: '0', // 激活的tab项 0接待1我的好友2我的店铺
				messageList: [], //聊天消息,好友,我的团队数组
				URL: 'http://kefu.tjztct.com',
				store_url: 'http://app.tjztct.com/', //商户系统url路径
				show_service_info: false, //显示客服信息
				show_cancellation_reason: false, //显示注销原因
				chatTargetInfo: {}, // 聊天对象的信息
				searchChatData: [], //聊天结果搜索结果
				searchUserData: [], //联系人搜索结果
				chat_id: 0, //聊天对象的id
				chat_name: '', // 聊天对象的昵称
				msgkey: '', // 聊天对象的msgkey
				chat_headImg: '', //聊天对象的头像
				friend_type: '', // 聊天对象的身份
				left_status: 4, //右侧边栏状态 0退款消息1交易消息2处罚与预警3其他消息4快捷短语5聊天记录6商品数据
				dialogPhrasesVisible: false, // 添加快捷短语弹出框
				phrases_textarea: '', //快捷短语文本
				chatList: [], //聊天消息数组
				//接待统计
				Census: {
					jd_num: 0,
					wfk_num: 0,
					wxd_num: 0,
					yfk_num: 0
				},
				page: 0,
				limit: 10,
				videoSrc: null, //视频播放路劲
				msgData: '', //聊天文字
				show_system_setting: false, //是否显示系统设置
				uploadData: {
					type: '',
					chat_type: 2,
					store_id: '',
					msgkey: ''
				}, //文件上传附带参数
				loadingInstance: null,
				not_read_msg_list: [], //未读消息数组
				notReadCount: 0, //未读消息条数
				self_mall_id: 2, // 自营商城店铺id
			}
		},
		methods: {
			// 显示消息内容
			showUserMessage(status){
				if (!this.chat_id||!this.msgkey) {
					this.$message.warning('请先选择聊天对象')
					return
				}
				this.left_status = status
				setTimeout(()=>{
					this.$refs.newslist.page = 0
					this.$refs.newslist.list = []
					this.$refs.newslist.getUserMessage()
				},300)
			},
			// 文本域获取焦点
			inputGetFocus() {
				console.log(this.$refs.textarea)
				this.$refs.textarea.focus()
			},
			// 标记已读
			markReaded(item) {
				console.log(item)
				console.log(this.not_read_msg_list.indexOf(item))
				var index = this.not_read_msg_list.indexOf(item)
				if (index != -1) {
					this.not_read_msg_list.splice(index, 1)
				}
			},
			//正则验证是否是图片格式
			testImg(dom) {
				var ImgType = ["gif", "jpeg", "jpg", "bmp", "png"]; //图片
				if (!RegExp("\.(" + ImgType.join("|") + ")$", "i").test(dom.toLowerCase())) {
					this.$message.error("不是指定图片格式,重新选择");
					return false;
				} else {
					return true
				}
			},
			//正则验证是否是视频格式
			testVideo(dom) {
				var VideoType = ["mpeg", "avi", "wmv", "rm", "rmvb", "mp4"]; //视频
				if (!RegExp("\.(" + VideoType.join("|") + ")$", "i").test(dom.toLowerCase())) {
					this.$message.error("不是指定视频格式,重新选择");
					return false;
				} else {
					return true
				}
			},
			// 播放语音
			playAudio(src) {
				console.log(this.URL + src)
				console.log(src)

				this.$refs.audio1.src = src

				// this.$refs.audio1.src = 'http://kefu.tjztct.com/' + src
				// var BenzAMRRecorder = require('benz-amr-recorder');
				// let amr = new BenzAMRRecorder()
				// amr.initWithUrl('v1' + src).then(function() {
				// 	amr.play()
				// })
				this.$refs.audio1.src = src
				var BenzAMRRecorder = require('benz-amr-recorder');
				let amr = new BenzAMRRecorder()
				src = src.replace(/^http:\/\/[^/]+/, "");
				amr.initWithUrl('/v2/' + src).then(function() {
					amr.play()
				})
			},
			// 上传文件的方法
			uploadFile(response, file, fileList) {
				if (this.uploadData.type == 'image') {
					//上传照片
					var that = this
					console.log(response.data)
					var bild = '{"type":"say","fromid":"' + this.usercode + '","toid":"' + this.chat_id +
						'","msgtype":"2","chat_type":"2","data":"' + response.data + '","msgkey":"' + this.msgkey +
						'","loginType":"pc","onlineType":"pc","store_id":"' + this.userinfo.store_id + '"}';
					console.log(bild)
					this.$http.send(bild)
				} else if (this.uploadData.type == 'video') {
					//上传视频
					var that = this
					var bild = '{"type":"say","fromid":"' + this.usercode + '","toid":"' + this.chat_id +
						'","msgtype":"3","chat_type":"2","data":"' + response.data + '","msgkey":"' + this.msgkey +
						'","loginType":"pc","onlineType":"pc","store_id":"' + this.userinfo.store_id + '"}';
					console.log(bild)
					this.$http.send(bild)
				}
			},
			playVideo(src) {
				this.videoSrc = src
			},
			closeVideo() {
				this.videoSrc = null
				console.log(this.videoSrc)
			},
			// 切换tab
			changeTab(e) {
				var that = this
				if (!e.target.dataset.active) {
					return
				}
				if (that.isActive != e.target.dataset.active) {
					// 没有重复点击自己时
					that.isActive = e.target.dataset.active;
					that.loadLeftList();
				}
			},
			// 点击聊天工具栏
			toolClickHandler(type) {
				console.log(type)
				switch (type) {
					// 0发送表情包 1发送图片 2发送视频 3快捷短语 4历史记录
					case 0:

						break;
					case 1:
						if (!this.chat_id) {
							this.$message.warning('请先选择聊天对象')
							return
						}
						this.uploadData.type = 'image'
						this.uploadData.chat_type = 2
						this.uploadData.store_id = this.userinfo.store_id
						this.uploadData.msgkey = this.msgkey
						break;
					case 2:
						if (!this.chat_id) {
							this.$message.warning('请先选择聊天对象')
							return
						}
						this.uploadData.type = 'video'
						this.uploadData.chat_type = 2
						this.uploadData.store_id = this.userinfo.store_id
						this.uploadData.msgkey = this.msgkey
						break;
					case 3:
						if (!this.chat_id) {
							this.$message.warning('请先选择聊天对象')
							return
						}
						this.$refs.phrases.friend_id = this.chat_id
						this.$refs.phrases.store_id = this.store_id
						this.left_status = 4
						break;
					case 4:
						if (!this.chat_id) {
							this.$message.warning('请先选择聊天对象')
							return
						}
						this.$refs.chatrecord.chatList = this.chatList;
						this.$refs.chatrecord.page = 0;
						this.left_status = 5
						break;
					default:
						break;
				}
			},
			// 打开快捷短语添加
			openPhrasesDialog() {
				this.dialogPhrasesVisible = true
			},
			// 关闭添加快捷短语弹窗
			async handlePhrasesClose(mode) {
				var that = this;
				this.dialogPhrasesVisible = false
				if (mode == 'define') {
					// 点击确定 快捷短语添加
					if (!this.phrases_textarea.trim()) {
						this.$message.warning('请输入要添加的快捷短语');
						return
					}
					var res = await that.$axios.post('/iMessage/setQuickPhrases', {
						User_code: that.usercode,
						content: that.phrases_textarea
					})
					if (res.data.done) {
						// 刷新列表
						that.$refs.phrases.loadQuickPhrases();
					} else {
						that.$message.error(res.data.msg);
					}
				}
			},
			// 关闭客服信息弹窗
			closePop() {
				this.show_service_info = false;
				this.show_cancellation_reason = false
				this.show_system_setting = false
			},
			// 退出
			logout() {
				window.location.replace('http://store.tjztct.com//index.php?app=member');
			},
			// 添加好友
			async addFriend() {
				var that = this
				var res = await that.$axios.post('/friends/addFriends', {
					User_code: that.usercode,
					friend_id: that.chat_id,
					friend_type: that.friend_type
				})
				if (res.data.done) {

				} else {
					this.$message.error(res.data.msg)
				}
			},
			// 注销账户
			logoutAccount() {
				this.show_setting_dropdown = false;
				this.show_cancellation_reason = true;
			},
			// 搜索联系人或消息
			async search() {
				var that = this;
				if (!this.searchText) {
					that.searchChatData = [];
					that.searchUserData = [];
					return
				}
				var res = await that.$axios.post('/friends/searchFriend', {
					User_code: that.usercode,
					search_field: that.searchText
				})
				if (res.data.done) {
					that.searchChatData = res.data.data.chatData;
					that.searchUserData = res.data.data.userData;
					if (that.searchChatData) {
						that.searchChatData.forEach(function(item, index) {
							item.userInfo[0].portrait = that.getAvitor(item.userInfo[0].portrait)
						})
					}
					if (that.searchUserData) {
						that.searchUserData.forEach(function(item, index) {
							item.portrait = that.getAvitor(item.portrait)
						})
					}
				} else {
					that.$message.error(res.data.msg);
				}
			},
			// 显示系统设置
			showSystemSet() {
				this.show_system_setting = true;
				this.$refs.SystemSetting.signature = this.userinfo.qm;
				console.log(this.userinfo.qm)
				if (this.userinfo.disturb_status == 0) {
					this.$refs.SystemSetting.disturb = false;
				} else {
					this.$refs.SystemSetting.disturb = true;
				}

			},
			// 关闭聊天窗
			closeChat() {
				this.chat_id = '';
				this.chat_name = '';
				this.msgkey = ''
				this.chat_headImg = ''
			},
			// 打开聊天窗
			openChat(msgkey, friend_id, real_name, chat_img, store_id) {
				console.log(friend_id)
				this.chat_id = Number(friend_id);
				this.$refs.phrases.friend_id = this.chat_id
				this.$refs.phrases.store_id = this.userinfo.store_id
				this.chat_name = real_name.join('-');
				this.msgkey = msgkey
				this.chat_headImg = chat_img
				this.page = 0;
				this.chatList = [];
				this.userinfo.store_id = store_id
				console.log('店铺' + this.userinfo.store_id)
				console.log(this.chatList)
				console.log(this.chat_name)
				this.loadChatList();
				this.isRead();
			},
			// 显示商品区域
			showGoods() {
				if (!this.chat_id) {
					this.$message.warning('请先选择聊天对象')
					return
				}
				this.$refs.goodslist.page = 0;
				this.$refs.goodslist.goodsList = [];
				this.$refs.goodslist.getGoosList();
				this.left_status = 6
			},
			// 显示工作台
			showOperatingFloor() {
				window.location.replace('http://store.tjztct.com//index.php?app=member');
			},
			// 数组倒序排列
			sortReverse(list) {
				list.reverse()
			},
			// 加载左侧列表
			loadLeftList() {
				var that = this;
				switch (that.isActive) {
					case '0':
						// 加载接待中
						that.loadMessageList()
						break;
					case '1':
						// 加载联系人列表
						that.loadContactList()
						break;
					case '2':
						//加载我的团队
						that.loadMyTeam()
						break;
					default:
						break;
				}
			},
			// 加载我的团队
			async loadMyTeam() {
				var that = this
				var res = await this.$axios.post('/friends/getStoreCs', {
					User_code: this.usercode,
					store_id: this.userinfo.store_id
				})
				if (res.data.done) {
					that.messageList = res.data.data
					that.messageList.forEach(function(item, index) {
						item.portrait = that.getAvitor(item.header_img)
						item.real_name = item.userCode.split('-');
						console.log(item.header_img)
					})
				} else {
					that.messageList = []
					that.$message.error(res.data.msg);
				}
			},
			async isRead() {
				var that = this
				var res = await this.$axios.post('/iMessage/isRead', {
					User_code: this.usercode,
					friend_id: this.chat_id,
					msgkey: this.msgkey
				})
			},
			// 加载联系人列表
			async loadContactList() {
				var that = this;
				var res = await this.$axios.post('/friends/loadFriendsList', {
					User_code: this.usercode
				})
				if (res.data.done) {
					that.messageList = res.data.data.list
					that.messageList.forEach(function(item, idex) {
						console.log(item)
						item.user_id = item.friend_id
						item.real_name = item.friendName.split('-')
						item.portrait = item.portrait
					})
				} else {
					that.messageList = []
					that.$message.error(res.data.msg);
				}
			},
			// 加载消息列表
			async loadMessageList() {
				var that = this;
				var res = await this.$axios.post('/iMessage/loadMsgList', {
					User_code: this.usercode
				})
				if (res.data.done) {
					that.messageList = res.data.data
					that.messageList = that.messageList.sort(that.sortNum)
					that.messageList.forEach(function(item, index) {
						item.portrait = that.getAvitor(item.userInfo.portrait)
						item.real_name = item.userInfo.real_name.split('-')
						item.user_id = item.userInfo.user_id
					})
				} else {
					that.messageList = []
					that.$message.error(res.data.msg);
				}
			},
			// 排序
			sortNum(a,b){
				return b.new_msg.add_time - a.new_msg.add_time
			},
			// 显示设置按钮
			showSetting() {
				this.show_setting_dropdown = !this.show_setting_dropdown;
			},
			// 切换客服状态
			async changServiceStatus(status) {
				var that = this;
				that.service_status = status;
				let status_desc;
				switch (status) {
					case 0:
						status_desc = '在线';
						break;
					case 1:
						status_desc = '离线';
						break;
					case 2:
						status_desc = '忙碌';
						break;
					case 3:
						status_desc = '隐身';
						break;
					default:
						break;
				}
				that.show_status_bar = false;
				var res = await that.$axios.post('/login/editOnlineStatus', {
					User_code: that.usercode,
					status: that.service_status,
					status_desc: status_desc,
					loginType: 'pc'
				})

			},
			closeCommonPop(){
				this.show_status_bar = false;
				this.show_setting_dropdown = false;
			},
			// 显示状态栏
			showStatusOrInfo(e) {
				console.log(e.target.dataset.type)
				if (e.target.dataset.type == 'img') {
					//显示客服资料
					this.show_service_info = true;
				} else {
					this.show_status_bar = true
				}
			},
			// 处理头像
			getAvitor(portrait) {
				var now_avitor;
				// console.log('处理头像')
				if (portrait == null || portrait == "null" || portrait == "") {
					now_avitor = 'http://service.tjztct.com/src/assets/default_portrait.png'
				} else if (portrait == '../image/default_portrait.png') {
					now_avitor = 'http://service.tjztct.com/src/assets/default_portrait.png'
				} else if (portrait != null || portrait != "null") {
					if (portrait.substr(0, 8).toLowerCase() == "https://" || portrait.substr(0, 7).toLowerCase() == "http://") {
						now_avitor = portrait;
					} else {
						now_avitor = 'https://xjhdapp.hzxjhd.com/' + portrait;
					}
				}
				// console.log(now_avitor)
				return now_avitor;
			},
			// 获取客服信息
			async getServiceInfo() {
				var that = this
				var res = await this.$axios.post('/friends/loadUserInfo', {
					User_code: this.usercode
				})
				if (res.data.done) {
					that.userinfo = res.data.data
					console.log(that.userinfo.header_img)
					if (that.userinfo.header_img) {
						that.userinfo.portrait = that.getAvitor(that.userinfo.header_img)
					} else {
						that.userinfo.portrait = that.getAvitor(that.userinfo.portrait)
					}
					that.service_status = res.data.data.pc_online_status
					// 获取今日接单统计
					that.getOrderCensus();
				} else {
					this.$message.error(res.data.msg);
				}
			},
			// 发送文字消息
			sendMessage() {
				var that = this
				if (!this.chat_id) {
					that.$message.warning('请先选择聊天对象')
					return
				}
				if (!this.msgData.trim()) {
					that.$message.warning('不能发送空消息')
					return
				}
				this.msgData = this.msgData.replace(/[\r\n]/g, "");
				var bild = '{"type":"say","fromid":"' + this.usercode + '","toid":"' + this.chat_id +
					'","msgtype":"0","chat_type":"2","data":"' + this.msgData + '","msgkey":"' + this.msgkey +
					'","loginType":"pc","onlineType":"pc","store_id":"' + this.userinfo.store_id + '"}';
				this.msgData = ''
				console.log(bild)
				this.$http.send(bild)
			},
			//发送表情包
			sendEmoji(e) {
				console.log(e.target.dataset.src)
				if (!e.target.dataset.src) {
					return
				}
				var bild = '{"type":"say","fromid":"' + this.usercode + '","toid":"' + this.chat_id +
					'","msgtype":"5","chat_type":"2","data":"' + e.target.dataset.src + '","msgkey":"' + this.msgkey +
					'","loginType":"pc","onlineType":"pc","store_id":"' + this.userinfo.store_id + '"}';
				console.log(bild)
				document.getElementById('emojibtn').click();
				this.$http.send(bild)
			},
			socketMessage() {
				var that = this
				var pre_time = Date.parse(new Date());
				that.$http.onmessage = function(e) {
					var message = eval("(" + e.data + ")");
					console.log(e.data)
					switch (message.type) {
						case "init":
							var bild = '{"type":"bind","fromid":"' + that.usercode +
								'","msgkey":"","chat_type":"2","loginType":"pc","onlineType":"pc"}';
							console.log('初始化socket成功')
							that.$http.send(bild);
							return;
						case "text":
							console.log('text');
							// 向未读消息数组添加
							that.not_read_msg_list.push(message.msgkey)
							that.refreshMsg(message)
							// 消息提醒
							var now_time = Date.parse(new Date());
							console.log(now_time)
							if (that.userinfo.disturb_status == 1) {
								if (now_time - pre_time > 1000) {
									//函数节流
									pre_time = now_time
									var audio = document.getElementById('remind_audio');
									console.log('播放')
									audio.play(); // 播放
									// that.speak('叮咚');
								}
							}
							return;
						case "save":
							// 存储消息
							console.log('save');
							that.saveMessage(message)
							that.refreshMsg(message)
							return;
						case 'login':
							that.logout()
							return
						case 'pclogin':
							// that.logout()
							return
						default:
							return;
					}
				};
			},
			// 存储消息
			async saveMessage(msg) {
				var res = await this.$axios.post('/iMessage/saveMsg', {
					fromid: msg.fromid,
					toid: msg.toid,
					msgtype: msg.msgtype,
					msgkey: msg.msgkey,
					data: msg.data,
					time: msg.time,
					isread: msg.isread,
					store_id: msg.store_id,
				})
			},
			// 获取接单统计
			async getOrderCensus() {
				var res = await this.$axios.post('/checkOrder/recordCSOrder', {
					store_id: this.userinfo.store_id,
					User_code: this.usercode,
				})
				if (res.data.done) {
					this.Census = res.data.data
				} else {
					this.$message.error(res.data.msg)
				}
			},
			// 加载订单信息
			async getCheckOrder(order_id, id,msg) {
				var that = this;
				var res = await this.$axios.post('/checkOrder/createOrder', {
					User_code: that.usercode,
					order_id: order_id,
				})
				if (res.data.done) {
					var orderInfo = {};
					if (res.data.data.check.res[0].id == 1) {
						orderInfo.id = res.data.data.order.order[0].order_id
					}
					if (res.data.data.check.res[0].open_sku == 1) {
						orderInfo.open_sku = res.data.data.order.goods[0].specification
					}
					if (res.data.data.check.res[0].open_specprice == 1) {
						orderInfo.open_specprice = res.data.data.order.goods[0].price
					}
					if (res.data.data.check.res[0].open_quantity == 1) {
						orderInfo.open_quantity = res.data.data.order.goods.length
					}
					if (res.data.data.check.res[0].open_orderprice == 1) {
						orderInfo.open_orderprice = res.data.data.order.order[0].goods_amount
					}
					if (res.data.data.check.res[0].open_actualprice == 1) {
						orderInfo.open_actualprice = res.data.data.order.order[0].order_amount
					}
					if (res.data.data.check.res[0].open_address == 1) {
						orderInfo.open_address = res.data.data.order.order[0].address
					}
					orderInfo.goods_name = res.data.data.order.goods[0].goods_name
					orderInfo.goods_image = res.data.data.order.goods[0].goods_image
					orderInfo.consignee = res.data.data.order.order[0].consignee
					orderInfo.phone_mob = res.data.data.order.order[0].phone_mob
					if (id == 'order') {
						msg.message = orderInfo;
						return msg
					}
					that.chatList.forEach(function(item, index) {
						item.forEach(function(item, index) {
							if (item.rowid == id) {
								item.message = orderInfo
							}
						})
					})
				} else {
					that.$message.error(res.data.msg)
				}
			},
			// 处理聊天消息的方法
			processingMessage(res) {
				var that = this;
				if (this.loadingInstance) {
					console.log('关闭')
					this.loadingInstance.close();
				}
				if (!res.data.done) {
					this.$message.error(res.data.msg);
					return
				}
				// this.chatList = res.data.data
				if (this.loadingInstance) {
					this.loadingInstance.close();
				}
				if (res.data.data.msglog.length == 0) {
					this.$message.warning('没有更多消息了')
					return
				}
				for (var i = 0; i < 2; i++) {
					console.log(i)
				}
				// 将消息处理为已读或者未读
				if (res.data.data.is_read == '') {
					res.data.data.is_read = 0
				}
				that.notReadCount = res.data.data.is_read
				var markCount = 0; //以转化的消息数
				console.log(that.notReadCount)
				for (let i = 0, j = 0; i < that.notReadCount;) {
					var flag = false
					for (; j < res.data.data.msglog.length;) {
						if (res.data.data.msglog[j].send_id == that.usercode) {
							//自己发送的消息
							console.log("i:" + i)
							console.log("j:" + j)
							res.data.data.msglog[j].not_read = true
							markCount++
							i++;
							j++;
							flag = true
							break;
						}
						j++;
					}
					if (!flag) {
						// 消息数组便利完毕 结束所有循环
						break
					}
					console.log(i)
					console.log('外循环')
				}
				that.notReadCount -= markCount
				res.data.data.msglog = res.data.data.msglog.reverse();
				var startTime = res.data.data.msglog[0].add_time;
				var i = 0; //时间数组的起始项
				res.data.time = []; //定义外层的时间数组
				res.data.data.msglog.forEach(function(item, index) {
					if (res.data.time[i] == undefined) {
						res.data.time[i] = []
					}
					if (item.msg_type == 4) {
						//订单信息块
						that.getCheckOrder(item.message, item.rowid)
					}
					if (item.msg_type == 6) {
						//商品信息块
						console.log()
						var obj = {}
						item.message.split(',').forEach(function(item, index) {
							var arr = item.split(':')
							if (arr[1] == 'http' || arr[1] == 'https') {
								obj[arr[0]] = arr[1] + ':' + arr[2]
							} else {
								obj[arr[0]] = arr[1]
							}
						})
						console.log(obj)
						item.message = obj
					}
					if (item.msg_type == 5) {
						//表情包
						var tempEmoji = item.message.split('/')
						item.message = require('@/static/emoji/' + tempEmoji[tempEmoji.length - 1])
					}

					if (item.add_time - startTime < 1800) {
						item.add_time = that.formatDateTime(item.add_time)
						item.add_time_hour = item.add_time.substr(11, 8)
						res.data.time[i].push(item)
					} else {
						startTime = item.add_time; //改变起始时间
						res.data.time[++i] = [];
						item.add_time = that.formatDateTime(item.add_time)
						res.data.time[i].push(item); //数组下标加一
					}
				})
				if (that.page > 0) {
					// 不是初始加载
					that.chatList = res.data.time.concat(that.chatList)
				} else {
					that.chatList = res.data.time
					setTimeout(function() {
						that.scrollBottom();
					}, 1000)
				}
				console.log(that.chatList)
			},
			// 加载聊天记录列表
			async loadChatList() {
				var that = this;
				this.loading_type = 1;
				console.log(that.msgkey)
				if (!that.msgkey) {
					return
				}
				console.log(that.chatList)
				console.log(that.chatList.length)

				var chatListLength = 0;
				if (that.chatList.length > 0) {
					//消息数组有内容时
					that.chatList.forEach(function(item, index) {
						chatListLength += item.length
					})
				}
				console.log('store_id' + this.userinfo.store_id)
				console.log("chatListLength:" + chatListLength)
				var res = await this.$axios.post('/iMessage/loadMsg', {
					page: chatListLength,
					msgkey: this.msgkey,
					to_id: this.chat_id,
					limit: this.limit,
					store_id: this.userinfo.store_id
				})
				this.processingMessage(res)
			},
			getUrlParam(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
				var r = window.location.search.substr(1).match(reg); //匹配目标参数
				if (r != null) return unescape(r[2]);
				return null; //返回参数值
			},
			formatDateTime(timeStamp) {
				var date = new Date();
				date.setTime(timeStamp * 1000);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				var second = date.getSeconds();
				minute = minute < 10 ? ('0' + minute) : minute;
				second = second < 10 ? ('0' + second) : second;
				return y + '/' + m + '/' + d + ' ' + h + ':' + minute + ':' + second;
			},
			// unicode转字符    escape() 函数可对字符串进行编码
			toStr(str) {
				str = str.replace(/(\\u)(\w{1,4})/gi, function(v) {
					return (String.fromCharCode(parseInt((escape(v).replace(/(%5Cu)(\w{1,4})/g, "$2")), 16)));
				});
				str = str.replace(/(&#x)(\w{1,4});/gi, function(v) {
					return String.fromCharCode(parseInt(escape(v).replace(/(%26%23x)(\w{1,4})(%3B)/g, "$2"), 16));
				});
				str = str.replace(/(&#)(\d{1,6});/gi, function(v) {
					return String.fromCharCode(parseInt(escape(v).replace(/(%26%23)(\d{1,6})(%3B)/g, "$2")));
				});
				return str;
			},
			//刷新消息列表
			async refreshMsg(msg) {
				var that = this;
				console.log('进来了')
				// 判断msgkey 是否 存在于消息列表 不存在则刷新消息列表
				var freshflag = true //是否刷新消息列表
				console.log(this.messageList)
				var tempItem = null; // 临时存储最新的消息项
				// 飞雷神
				console.log('消息key:' + msg.msgkey)
				this.messageList.forEach(function(item, index) {
					if (msg.msgkey == item.msgkey) {
						//不刷新消息列表
						console.log('找到了')
						tempItem = that.messageList.splice(index, 1)[0]
						freshflag = false
						return
					}
				})
				console.log('最新的消息项:')
				console.log(tempItem)
				if(tempItem){
					// 找到最新消息项则置顶
					this.messageList.unshift(tempItem)
				}else{
					// 等刷新
				}
				if (freshflag) {
					//刷新消息列表
					setTimeout(function() {
						that.loadLeftList()
					}, 1000)
				}
				console.log('当前msgkey:',this.msgkey)
				console.log('消息来自的消息key:',msg.msgkey)
				// if (msg.fromid != this.chat_id && msg.fromid != this.usercode) {
				// 	//发送id不是聊天id且不是自己发的
				// 	return
				// }
				if (msg.msgkey != this.msgkey||!this.msgkey) {
					//新消息的key 和 当前聊天的key不相同则不刷新消息 同时有聊天对象
					return
				}
				msg.data = that.toStr(msg.data)
				//当前消息时间戳
				var timestamp = msg.time;
				// 最后一个消息时间段的时间戳
				var msgLength = that.chatList.length - 1
				console.log(msgLength)
				if (that.chatList.length != 0) {
					//存在消息
					console.log('存在消息')
					var date = that.chatList[msgLength][0].add_time
					var lastTime = Date.parse(date) / 1000
				} else {
					//没有消息
					console.log('没有消息')
					msgLength = 0
					var lastTime = timestamp
				}
				msg.send_id = msg.fromid;
				msg.receive_id = msg.toid
				msg.msg_type = Number(msg.msgtype)
				msg.message = msg.data
				msg.add_time = that.formatDateTime(msg.time)
				msg.is_new = msg.isread
				console.log(msg.isread)
				if (msg.isread == 0) {
					// 已读 cqf说的
					msg.not_read = false
				} else {
					// 未读 cqf说的
					msg.not_read = true
				}
				if (msg.msg_type == 5) {
					//表情包
					var tempEmoji = msg.message.split('/')
					msg.message = require('@/static/emoji/' + tempEmoji[tempEmoji.length - 1])
				}
				if (msg.msg_type == 4) {
					//获取核对订单数据
					msg = await that.getCheckOrder(msg.message, 'order', msg)
					console.log('msg')
					console.log(msg)
				}
				if (msg.msg_type == 6) {
					//商品信息块
					console.log()
					var obj = {}
					msg.message.split(',').forEach(function(item, index) {
						var arr = item.split(':')
						if (arr[1] == 'http' || arr[1] == 'https') {
							obj[arr[0]] = arr[1] + ':' + arr[2]
						} else {
							obj[arr[0]] = arr[1]
						}
					})
					console.log(obj)
					msg.message = obj
				}
				if (timestamp - lastTime > 1800) {
					//加入下一个数组
					that.chatList.push([msg])
				} else {
					console.log(that.chatList)
					if (that.chatList.length == 0) {
						that.chatList[msgLength] = []
					}
					that.chatList[msgLength].push(msg)
					console.log(that.chatList)
				}
				that.$forceUpdate();
				setTimeout(function() {
					that.scrollBottom();
				}, 1000)

			},
			// 语音提醒
			speak(text) {
				if ('speechSynthesis' in window) {
					var sentence = new SpeechSynthesisUtterance();
					var voices = window.speechSynthesis.getVoices();
					for (var i = 0; i < voices.length; i++) {
						if (voices[i]['name'] == "Alex") {
							sentence.voice = voices[i];
						}
					}
					sentence.pitch = 1;
					sentence.rate = 0.7; //速度
					sentence.text = text;
					window.speechSynthesis.speak(sentence);
				} else {
					console.log("Oops! Your browser does not support HTML SpeechSynthesis.")
				}
			},
			//最后一个元素显示在最下面
			scrollBottom() {
				if (!document.getElementsByClassName('end')[0]) {
					return
				}
				document.getElementsByClassName('end')[0].scrollIntoView()
			},
			//监听触顶
			initTopLoad() {
				var that = this
				// console.log(document.getElementById('msgScroll'))
				document.getElementById('msgScroll').onscroll = function() {
					var scrollTop = document.getElementById('msgScroll').scrollTop; //变量windowHeight是可视区的高度
					if (document.getElementById('msgScroll').scrollHeight > (document.getElementById('msgScroll').innerHeight)) {
						return
					}
					if (scrollTop == 0) {
						//显示加载
						console.log('上拉加载')
						that.loadingInstance = Loading.service({
							lock: true,
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						})
						that.page++
						that.loadChatList();
					}
				}
			},
			// 开启警告铃声
			openRing() {
				this.$confirm('点击允许声音提示?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var audio = document.getElementById('remind_audio');
					// console.log('播放')
					audio.play(); // 播放
					setTimeout(() => {
						audio.pause()
						audio.load()
					}, 10)
				}).catch(() => {
					var audio = document.getElementById('remind_audio');
					console.log('播放')
					audio.play(); // 播放
					setTimeout(() => {
						audio.pause()
						audio.load()
					}, 10)
				});
			}
		},
		created() {
			this.usercode = this.getUrlParam('user_id');
			console.log(this.usercode)
			this.getServiceInfo();
			// 开启socket的监听
			this.socketMessage();
			// 允许用户交互
			this.openRing()
		},
		mounted() {
			// 设置rem布局
			var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值,使用100px只是为了方便计算 其他值都可以
			var wW = window.innerWidth; // 当前窗口的宽度
			var rem = wW * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
			document.getElementsByClassName("service-img")[0].style.fontSize = rem + 'px'
			this.initTopLoad();
		}
	}
</script>

<style scoped="scoped">
	.home,
	.el-container {
		width: 100%;
		height: 100%;
	}

	.header {
		background-color: #354052;
		color: #fff;
		display: flex;
		width: 100vw;
		height: 100px !important;
		align-items: center;
		padding: 0;
	}

	.main-container {
		height: calc(100vh - 100px);
	}

	.Msgactive {
		background-color: #e1e7f0;
		color: #4b73ec;
	}

	.self-name {
		color: #4b73ec;
		font-size: 14px;
	}

	.chat-name {
		color: #5ea742;
		font-size: 14px;
	}

	.service-information {
		width: 600px;
		height: 460px;
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 3;
		transform: translate3d(-50%, -50%, 0);
		background-color: #FFFFFF;
		border-radius: 5px;
	}

	.system_setting {
		width: 660px;
		height: 440px;
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 3;
		transform: translate3d(-50%, -50%, 0);
		background-color: #FFFFFF;
		border-radius: 10px;
		box-shadow: 10px 10px 5px #888888;
	}

	.service-info {
		height: 100%;
		width: 15%;
		padding-left: 22px;
		display: flex;
		box-sizing: border-box;
		position: relative;
	}

	.service-status {
		position: absolute;
		background-color: #fff;
		width: 135px;
		height: 156px;
		left: 54px;
		border-radius: 5px;
		top: 90%;
		z-index: 2;
	}

	.service-info .service-left {
		width: 25%;
		height: 100%;
		display: flex;
		align-items: center;
		float: left;
		position: relative;
	}

	.service-left .service-img {
		border-radius: 50%;
		/* width: 0.64em; */
		width: 64px;
		height: 64px;
		/* height: 0.64em; */
	}

	.service-left .iconfont {
		position: absolute;
		bottom: 20%;
		right: 10%;
	}

	.service-right {
		width: 75%;
		height: 100%;
		font-size: 14px;
		padding: 27px 0 25px 11px;
		box-sizing: border-box;

	}

	.service-right .service-id,
	.service-right .service-id {
		width: 100%;
		display: inline-block;
	}

	.service-name {
		font-size: 18px;
	}

	.search-message {
		display: flex;
		flex-wrap: wrap;
	}

	.search-message span {
		width: 100%;
	}

	.data-statistics {
		width: 28%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.data-statistics-item {
		display: inline-block;
		padding-left: 20px;
		padding-right: 20px;
		height: 44px;
		text-align: center;
	}

	.data-statistics-item span {
		width: 100%;
		display: inline-block;
	}

	.data-statistics-num {
		font-size: 18px;
	}

	.data-statistics-type {
		font-size: 14px;
	}

	.right-border {
		position: relative;
		height: 44px;
	}

	.right-border:after {
		content: '';
		position: absolute;
		background-color: #fff;
		right: 0px;
		width: 2px;
		height: 90%;
		top: 50%;
		transform: translateY(-50%);
	}

	/* 搜索结果 */
	.search-result {
		background-color: #fff;
		width: 15%;
		max-height: calc(100% - 190px);
		overflow: auto;
		z-index: 3;
		box-sizing: border-box;
		padding-left: 24px;
		font-size: 14px;
		color: #333;
		padding-bottom: 18px;
		position: absolute;
	}

	.search-result p {
		margin: 0;
		box-sizing: border-box;
		height: 35px;
		line-height: 35px;
	}

	.search-result li {
		list-style: none;
		box-sizing: border-box;
		height: 30px;
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.search-result li img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 10px;
	}

	.message-cate {
		width: 34.5%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.message-item {
		padding-left: 16px;
		padding-right: 16px;
		font-size: 14px;
		height: 24px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		color: #fff;
		cursor: pointer;
	}

	.setting {
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		width: 22.5%;
		height: 100%;
		position: relative;
		box-sizing: border-box;
	}

	.setting .iconfont {
		font-size: 20px;
		padding-right: 15px;
		padding-top: 13px;
	}

	.service-status {
		background-color: #fff;
		padding: 10px 12px;
		font-size: 22px;
		color: #333;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.status-item {
		display: flex;
		align-items: center;
	}

	.status-item .iconfont {
		font-size: 12px;
		margin-right: 10px;
	}

	.status-item .icongouxuandanxuan {
		font-size: 22px;
		margin-left: 20px;
	}

	/* 伪类实现三角形 */
	.triangle {
		/* position: relative; */
	}

	.service-info .triangle::after {
		content: "";
		width: 0;
		height: 0;
		position: absolute;
		top: -10px;
		left: 12px;
		border-right: solid 10px transparent;
		border-left: solid 10px transparent;
		border-bottom: solid 10px white;
	}

	.setting_dropdown {
		background-color: #fff;
		width: 187px;
		height: 120px;
		position: absolute;
		top: 45px;
		right: 5px;
		color: #000000;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.setting .triangle::after {
		content: "";
		width: 0;
		height: 0;
		position: absolute;
		top: -10px;
		right: 12px;
		border-right: solid 10px transparent;
		border-left: solid 10px transparent;
		border-bottom: solid 10px white;
	}

	.setting_dropdown_item {
		display: flex;
		cursor: default;
	}

	.message_contact_list {
		width: 15% !important;
		background-color: #f5f5f5;
		height: 100%;
	}

	.search-box {
		height: 44px;
		margin-bottom: 8px;
	}

	.search-tab {
		border-bottom: 1px solid #eee;
		height: 48px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		justify-content: space-around;
	}

	.search-tab .iconfont {
		font-size: 26px;
	}

	.active {
		color: #4b73ec;
		position: relative;
	}

	.active:after {
		content: "";
		display: block;
		position: absolute;
		bottom: -10px;
		left: -25%;
		width: 150%;
		height: 2px;
		background: #4b73ec;
	}

	.search-title {
		box-sizing: border-box;
		padding: 0 24px;
		display: flex;
		width: 100%;
		height: 40px;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #888;
	}

	.message-list {
		width: 100%;
		height: calc(100% - 182px);
		padding-left: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.foot-bar {
		width: 100%;
		height: 42px;
		background-color: #FFFFFF;
		display: flex;
		align-items: center;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.foot-bar .iconfont {
		font-size: 18px;
		padding: 3px;
		margin-right: 25px;
	}

	.foot-bar .iconfont:hover {
		background-color: #999;
	}

	.message-list-item {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding: 0 24px;
	}

	.message-list-item span {
		font-size: 16px;
		display: flex;
		width: calc(100% - 40px);
		flex-wrap: wrap;
		align-items: center;
	}

	.message-list-item span .message-name {
		width: 100%;
		height: 20px;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.message-list-item span .message-name-small {
		font-size: 12px !important;
		color: #888 !important;
	}

	.msg-warn-flag {
		width: 10px !important;
		height: 10px;
		background-color: #4b73ec;
		color: #fff;
		text-align: center;
		border-radius: 50%;
		display: inline-block;
		margin-left: 10px;
	}

	.message-list-item img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 10px;
	}

	/* 聊天区域 */
	.chat-area {
		width: 62.5% !important;
		margin: 0;
		padding: 0;
	}

	.chat-top {
		width: 100%;
		height: 45px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding-left: 12px;
		padding-right: 24px;
		border-bottom: 1px solid #eee;
	}

	.message-label {
		font-size: 12px;
		color: #888;
	}

	.chat-top .chat-target-img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 10px;
	}

	.message-item-name {
		margin: 24px 15px 0;
	}

	.message-item-content-container {
		color: #333;
		font-size: 16px;
	}

	.message-item-content-container p {
		margin: 5px 15px;
	}

	.chat-top-box {
		display: flex;
		align-items: center;
	}

	.chat-target-name {
		font-size: 18px;
		color: #333;
	}

	.chat-top-box .iconfiladaogou-tianjiahaoyou {
		font-size: 26px;
	}

	.chat-main {
		background-color: #fff;
		width: 100%;
		height: calc(100% - 45px);
	}

	.chat-main .chat-message {
		width: 100%;
		height: 74%;
		box-sizing: border-box;
		border-bottom: 1px solid #ccc;
		overflow: auto;
	}

	.chat-main .chat-tool {
		width: 100%;
		height: 26%;
		box-sizing: border-box;
		position: relative;
	}

	.msg-record-time {
		color: #888;
		font-size: 12px;
	}

	.chat-tool .toolbar {
		width: 100%;
		height: 37px;
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		line-height: 45px;
		padding-left: 30px;
		padding-right: 35px;
	}

	.toolbar .iconfont {
		font-size: 20px;
		color: #999;
	}

	.toolbar .iconfont:hover {
		background-color: #ccc;
	}

	.toolbar .left-bar .iconfont {
		margin-right: 25px;
		padding: 3px;
	}

	.toolbar .right-bar .iconfont {
		margin-left: 20px;
	}

	/* 右侧边栏 */
	.goods-notice-area {
		width: 22.5% !important;
		height: 100%;
		border-left: 1px solid #f5f5f5;
		background-color: #f5f5f5;
	}

	.quick-phrases,
	.chat-record,
	.goodslist {
		width: 100%;
		height: 100%;
		background-color: #fff;
	}

	.phrases-dialog {
		padding-top: 10vh;
	}

	.video {
		position: absolute;
		width: 500px;
		height: 400px;
		z-index: 9;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		object-fit: fill !important;
	}

	.close-video {
		position: absolute;
		font-size: 30px;
		z-index: 9;
		top: 50%;
		left: 50%;
		transform: translate(270px, -200px);
	}

	.msg-textarea {
		width: 100%;
		height: 30%;
		box-sizing: border-box;
		outline: none;
		border: none;
		resize: none;
		overflow: hidden;
		padding-left: 18px;
	}

	.msg-btn1 {
		width: 80px;
		height: 26px;
		position: absolute;
		bottom: 33px;
		right: 135px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.msg-btn2 {
		width: 80px;
		height: 26px;
		position: absolute;
		bottom: 33px;
		right: 35px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.emoji-row {
		display: flex;
		width: 100%;
		box-sizing: border-box;
		justify-content: space-around;
	}

	.emoji-row img {
		width: 30px;
		height: 30px;
	}

	.upload-file {
		display: inline-block !important;
	}

	.message-goods {
		width: 50%;
	}

	.goods-left {
		width: 125px;
		height: 125px;
		float: left;
	}

	.goods-left img {
		width: 100%;
		height: 100%;
	}

	.goods-right {
		width: calc(100% - 150px);
		float: left;
		height: 150px;
	}

	.msg-goods-name {
		height: 45px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.msg-goods-price {
		width: 100%;
		font-size: 16px;
		color: #333;
		height: 50px;
	}

	.text-ellipsis {
		white-space: nowrap;
		/*设置不换行*/
		overflow: hidden;
		/*设置隐藏*/
		text-overflow: ellipsis;
		/*设置隐藏部分为省略号*/
	}
</style>
